const checkExpanded = (idString) => {
    const toggleButtonDom = document
        .getElementById(idString)
        .getElementsByClassName('navbar-toggle')[0];
    return window.getComputedStyle(toggleButtonDom).display !== 'none';
};

export default checkExpanded;
